import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { rem } from 'polished'
import { media, Grid } from '../../utils/style'
import {
  splitUrlByFolderPath,
  matchUrlToActiveSection
} from '../../utils/location'

import IconArrowDown from '../../vectors/IconArrowDown'

/*************************
 STYLES: Bread-crumb
 **************************/

const navigationlinkStyle = `
  text-decoration: none;
  text-transform: uppercase;
  font-size: ${rem('14.5px')};
  font-weight: 600;
  letter-spacing: 0.12em;
  opacity: 0.6;
  display: block;
  &:hover {
    opacity: 1;
  }
}`

const BreadCrumb = styled(({ theme, ...rest }) => <Grid {...rest} />)`
  vertical-align: baseline;
  text-transform: capitalize;
  font-weight: 600;
  color: ${(props) => props.theme.colors.grey_light_op65};
  @media (max-width: ${(props) => props.theme.mediaBreakpoints[2]}px) {
    display: none;
  }

  a {
    color: ${(props) => props.theme.colors.blue};
    opacity: 1 !important;
    float: left;
    padding: 0;
    margin-bottom: -1px;
    padding-right: 3px;
    margin-right: 10px;
    transition: opacity 0.3s ${(props) => props.theme.ease.ease_out_expo},
      color 0.3s ${(props) => props.theme.ease.ease_out_expo};
    ${navigationlinkStyle}

    &:hover {
      color: ${(props) => props.theme.colors.grey};
      opacity: 1 !important;
    }
  }

  svg {
    transform: rotate(-90deg) translate(0, 5px);
  }

  &:nth-last-child(-n + 2) {
    svg path {
      fill: ${(props) => props.theme.colors.grey_light_op65};
    }
  }
`

const BreadCrumbCutOff = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.5;
  text-overflow: ellipsis;
  ${media.LargeScreenUp`
    max-width: 10%;
  `};
  ${media.GiantScreenUp`
    max-width: 24%;
  `};
`

class RouterBreadCrumb extends React.PureComponent {
  render() {
    const sections = this.props.sections
    const locationPath =
      typeof window !== 'undefined' && !this.props.location
        ? document.location.pathname
        : this.props.location
    const match = matchUrlToActiveSection(sections, locationPath)
    const breadcrumb = splitUrlByFolderPath(locationPath).slice(0, 1)
    let buildURL = ''

    var count = 0
    const breadcrumbs = match.found
      ? breadcrumb.map((section) => {
          buildURL += '/' + section
          count++
          const Arrow = count !== breadcrumb.length ? <IconArrowDown /> : null
          const Clickable =
            count === breadcrumb.length && count > 1 ? (
              <BreadCrumbCutOff key={`breadcrumbcutoff:${section}:${count}`}>
                {section.replace(/-/g, ' ')}
              </BreadCrumbCutOff>
            ) : (
              <Link
                key={`breadcrumblink:${section}:${count}`}
                to={`${buildURL}`}
                activeClassName="active"
              >
                {section.replace(/-/g, ' ')}
                {Arrow}
              </Link>
            )

          return (
            <BreadCrumb key={`breadcrumb:${section}:${count}`}>
              {Clickable}
            </BreadCrumb>
          )
        })
      : null
    return <span>{breadcrumbs}</span>
  }
}

export default RouterBreadCrumb
